import { Shield, Plus, Zap } from "lucide-react";
import { cn } from "@/lib/utils";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";

interface CreditMenuProps {
  credits: number;
  isLoading: boolean;
  onUpgrade: () => void;
  onRefill: () => void;
}

const CreditMenu = ({ credits, isLoading, onUpgrade, onRefill }: CreditMenuProps) => {
  const creditColor =
    credits > 3
      ? "text-cyan"
      : credits >= 1
      ? "text-amber-400"
      : "text-red-500";

  const creditBg =
    credits > 3
      ? "bg-cyan/10 border-cyan/20"
      : credits >= 1
      ? "bg-amber-400/10 border-amber-400/20"
      : "bg-red-500/10 border-red-500/20";

  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          className={cn(
            "flex items-center gap-1.5 px-2.5 sm:px-3 py-1.5 rounded-lg border min-h-[36px] transition-colors hover:opacity-80",
            creditBg,
            creditColor
          )}
          title="Rehearsal Credits"
        >
          <Shield className="w-3.5 h-3.5" />
          <span className="text-xs font-mono font-semibold tabular-nums">
            {isLoading ? "..." : credits}
          </span>
          <span className="hidden sm:inline text-[10px] uppercase tracking-[0.14em] font-mono opacity-70">
            Credits
          </span>
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-64 p-0 bg-card border-border">
        <div className="p-4 border-b border-border">
          <div className="flex items-center gap-2 mb-1">
            <Shield className={cn("w-4 h-4", creditColor)} />
            <span className={cn("text-lg font-bold font-mono tabular-nums", creditColor)}>
              {credits}
            </span>
            <span className="text-sm text-muted-foreground">Rehearsal Credits</span>
          </div>
          <p className="text-xs text-muted-foreground">
            Access to AI behavioral rehearsal, analysis, and strategy. Never expires.
          </p>
        </div>
        <div className="p-2 space-y-1">
          <button
            onClick={onUpgrade}
            className="w-full flex items-center gap-2 px-3 py-2 rounded-md text-sm font-medium text-foreground hover:bg-secondary transition-colors text-left"
          >
            <Zap className="w-4 h-4 text-cyan" />
            Extend Access
          </button>
          <button
            onClick={onRefill}
            className="w-full flex items-center gap-2 px-3 py-2 rounded-md text-sm font-medium text-foreground hover:bg-secondary transition-colors text-left"
          >
            <Plus className="w-4 h-4 text-cyan" />
            Buy 10 Credits — $4.99
          </button>
        </div>
      </PopoverContent>
    </Popover>
  );
};

export default CreditMenu;
